interface IRcDelete {
  url: string
  candidateId: string
}

export async function deleteReportCardLinks(ids: IRcDelete[] | IRcDelete) {
  try {
    const candidateIds = ids && Array.isArray(ids) ? ids : [ids]
    console.log(candidateIds, 'candidateIds')
    const deleteResponse =
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/remove/scorecard-link`, {
      // await fetch('http://localhost:3001/remove/scorecard-link', {
        method: 'POST',
        body: JSON.stringify({ candidateIds }),
        headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
      })
      if(deleteResponse.ok && deleteResponse.status === 204){
        return {status:true,message:'The items have been successfully deleted.'}
      }
      return {status:false,message:'Failed to complete the delete process...'}
  } catch (err) {
    console.log(err, 'ERROR')
    return {status:false,message:'Server down, please contact the AMS admin!'}
  }
}
